import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      d: "M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18"
    }, null, -1),
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      d: "M8.4 9.84c0-.504 0-.756.098-.949a.9.9 0 0 1 .393-.393c.193-.098.445-.098.949-.098h4.32c.504 0 .756 0 .949.098a.9.9 0 0 1 .393.393c.098.193.098.445.098.949v4.32c0 .504 0 .756-.098.949a.9.9 0 0 1-.393.393c-.193.098-.445.098-.949.098H9.84c-.504 0-.756 0-.949-.098a.9.9 0 0 1-.393-.393c-.098-.193-.098-.445-.098-.949z"
    }, null, -1)
  ])))
}
export default { render: render }